class EventFlashSaleFBT extends HTMLElement {
    constructor() {
        super();
        this._productSelector = '.event-flash-sale-fbt-product';
        this._parent = this.parentElement;
        this._addCartButtonParent = this._parent?.nextElementSibling;
        while (this._addCartButtonParent && !this._addCartButtonParent.classList.contains('event-flash-sale-product-btn-box')) {
            this._addCartButtonParent = this._addCartButtonParent.nextElementSibling;
        }
        this._addCartButton = this._addCartButtonParent?.querySelector('add-cart-button');
        this._buyNowButton = this._addCartButtonParent?.querySelector('buy-now-button');
        this._products = [];
    }

    connectedCallback() {
        if (!this._addCartButton) {
            console.error("Cannot find <add-cart-button> element");
            return;
        }
        if (!this._buyNowButton) {
            console.error("Cannot find <buy-now-button> element");
            return;
        }

        this._products = Array.from(this.querySelectorAll(this._productSelector));

        this._products.forEach(product => {
            product.addEventListener('click', this._onProductClick.bind(this));
        });
    }

    _onProductClick(event) {
        const product = event.currentTarget;
        const variantId = product.getAttribute('data-variant-id');

        if (product.classList.contains('active')) {
            product.classList.remove('active');
            this._removeVariantId(variantId);
        } else {
            product.classList.add('active');
            this._addVariantId(variantId);
        }
    }

    _addVariantId(variantId) {
        this._updateVariantId(variantId, 'add');
    }

    _removeVariantId(variantId) {
        this._updateVariantId(variantId, 'remove');
    }

    _updateVariantId(variantId, action) {
        const updateIds = (element, variantId, action) => {
            let currentIds = element.getAttribute('data-variant-id').split(',');
            if (action === 'add' && !currentIds.includes(variantId)) {
                currentIds.push(variantId);
            } else if (action === 'remove') {
                currentIds = currentIds.filter(id => id !== variantId);
            }
            element.setAttribute('data-variant-id', currentIds.join(','));
        };

        updateIds(this._addCartButton, variantId, action);
        updateIds(this._buyNowButton, variantId, action);
    }
}

customElements.define('event-flash-sale-fbt', EventFlashSaleFBT);
